import servicesConfig, { CustomAxiosHeaders } from '../config/services'
import { requests } from '.'
import { AD_PUBLISHING_CONNECT_BM_LOCATION } from '../util/constants'
import { AxiosResponse } from 'axios'

// Configure request setup
const serviceName = 'AdPublishingService'
const host = servicesConfig.AdPublishingService // Use the URL from config
const opts: CustomAxiosHeaders = { host, serviceName }
const request = (addlOpts?: CustomAxiosHeaders) => {
  return requests(Object.assign({}, opts, addlOpts))
}

// Helper function to handle response (similar to BaseService.responseBody)
const responseBody = (res: AxiosResponse) => res.data

// Define service object with all methods
const AdPublishingService = {
  getPricingModel: (companyId: string) => 
    request().get('/pricing-model', { params: { companyId } }).then(responseBody),
    
  updatePricingModel: (companyId: string, type: string) => 
    request().post('/pricing-model', { companyId, type }).then(responseBody),
    
  getCompanySubscription: (companyId: string, productCode?: string) => 
    request().get(`/reselling/subscription/company/${companyId}${productCode ? `?productCode=${productCode}` : ''}`).then(responseBody),
    
  getLocationSubscription: (locationId: string, productCode = AD_PUBLISHING_CONNECT_BM_LOCATION) => 
    request().get(`/reselling/subscription/location/${locationId}?productCode=${productCode}`).then(responseBody),
    
  getCompanyConfiguration: (companyId: string) => 
    request().get(`/reselling/configuration/company/${companyId}?productCode=${AD_PUBLISHING_CONNECT_BM_LOCATION}`).then(responseBody),
    
  updateCompanyConfiguration: (companyId: string, configuration: {amount: number}) => 
    request().put(`/reselling/configuration/company/${companyId}?productCode=${AD_PUBLISHING_CONNECT_BM_LOCATION}`, configuration).then(responseBody),
    
  getLocationConfiguration: (locationId: string, productCode = AD_PUBLISHING_CONNECT_BM_LOCATION) => 
    request().get(`/reselling/configuration/location/${locationId}?productCode=${productCode}`).then(responseBody),
    
  updateLocationConfiguration: (locationId: string, configuration: {amount?: number, offeringEnabled?: boolean}, productCode = AD_PUBLISHING_CONNECT_BM_LOCATION) => 
    request().put(`/reselling/configuration/location/${locationId}?productCode=${productCode}`, configuration).then(responseBody),
    
  agencyDirectPurchase: (locationId: string, productCode = AD_PUBLISHING_CONNECT_BM_LOCATION, payload = {}) => 
    request().post(`/reselling/subscription/location/${locationId}?productCode=${productCode}`, payload).then(responseBody),
    
  getAdwords: (locationId: string) => 
    request().get(`/google/conversions?locationId=${locationId}`).then(responseBody)
}

export default AdPublishingService